export enum ScanType {
  CustomerEquipment = 'CUSTOMER_EQUIPMENT',
  Equipment = 'EQUIPMENT',
  Part = 'PART',
}
